<template>
  <TextPreview v-bind="$attrs" :content="content" :padded="shouldPad" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import TextPreview from './TextPreview.vue'

interface ContentData {
  text?: string
}

interface Content {
  data?: ContentData
}

defineOptions({
  inheritAttrs: false,
  // eslint-disable-next-line vue/order-in-components
  name: 'TextSectionBuilderPreview',
})

defineProps<{
  content: Content
}>()

const route = useRoute()

const shouldPad = computed((): boolean => {
  // OTC Text previews and editable builder previews should show padding.
  // Automated campaign previews (e.g. /marketing/automations/hot-launch) should not.
  return (
    typeof route.name === 'string' && route.name.includes('.marketing.texts')
  )
})
</script>
